export enum LoginContext {
  SCHOOL = "SCHOOL",
  FAMILY = "FAMILY"
}